import React from "react";
import { Route, Routes } from "react-router-dom";
import AdminLogin from "../Admin/AdminNav/Login";
import Users from "../Admin/Users/Users";
import Events from "../Admin/Events/Events";
import AddService from "../Admin/Services/AddService";

import Allservice from "../Admin/Services/Allservices";
import Allusers from "../Admin/AllUsers/Allusers";
import AddSubService from "../Admin/Services/SubService/AddSubService";
import SDetails from "../Admin/SDetails/SDetails";
import UserDetailsCard from "../Admin/UserDetailsCard/UserDetailsCard";
import SingleEventDetails from "../Admin/Events/SingleEventDetails";
import Astro from "../Admin/AllUsers/Astro/Astro";
import Expense from "../Admin/Expense/Expense";
import Gallery from "../Admin/Gallery/Gallery";
import Birthday from "../Admin/Birthday/Birthday";
import Submissions from "../Admin/Submissions/Submissions";
import Youtube from "../Admin/Youtube/Youtube";
import Kashi from "../Admin/Kashiyatra/Kashi";
import Family from "../Admin/AllUsers/Family/Family";
import Employee from "../Admin/Employee/Employee";
import Occupation from "../Admin/Occupation/Occupation";
import Welcome from "../Admin/Welcome/Welcome";
export default function Allpages() {

  return (
    <Routes>
      

      <Route path="/" element={<AdminLogin />}></Route>

      {/* Nav Tabs Appointmnets Astro Events */}
      <Route path="/admin/appointments" element={<Users />}></Route>
      <Route path="/admin/astro" element={<Astro />}></Route> 
      <Route path="/admin/Events" element={<Events />}></Route>

      {/* Detailed user card */}
      <Route path="/admin/usersDtails/:id" element={<UserDetailsCard />}></Route>
      
      {/* Event Details in detailed user card */}
      {/* <Route path="/admin/userEvents/:id" element={<SingleEventDetails />}></Route> */}


      <Route path="/admin/users" element={<Allusers />}></Route>
     
      {/* <Route path="/admin/AddService" element={<AddService />}></Route>      
      <Route path="/admin/allservice/:id" element={<Allservice />}></Route>
      <Route path="/admin/AddSubService" element={<AddSubService />}></Route>
      <Route path="/admin/sdetails/:id" element={<SDetails />}></Route> */}
     
     
      <Route path="/admin/kashiyatra" element={<Kashi />}></Route>
     
      <Route path="/admin/userFamily/:id" element={<Family/>}></Route>

      <Route path="/admin/revenue" element={<Expense />}></Route>
      <Route path="/admin/gallery" element={<Gallery />}></Route>
      <Route path="/admin/birthday" element={<Birthday />}></Route>
      <Route path="/admin/submissions" element={<Submissions />}></Route>
      <Route path="/admin/youtube" element={<Youtube />}></Route>      
      <Route path="/admin/employee" element={<Employee />}></Route>
      <Route path="/admin/occupation" element={<Occupation />}></Route>
      <Route path="admin/welcome" element={<Welcome/>}></Route> 
    </Routes>
  );
}
